import client from '@/api/client';
import { BASE_URL } from '@/constants';
import { objectToQueryString } from '@/utils/sfaas_temp';

export default {
	async getCommCodes(codeType, plantCd) {
		try {
			const response = await client.get(`${BASE_URL}/cc/v1/plants/${plantCd}/commonCodes?commCdType=${codeType}`);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async getList({ searchParams, currentPage, pageUnit }) {
		const queryStr = objectToQueryString({
			strDt: searchParams.strDt,
			endDt: searchParams.endDt,
			pmcNo: searchParams.pmcNo,
			custCd: searchParams.custCd,
			custNm: searchParams.custNm,
			lastYn: searchParams.lastYn,
			currentPage,
			pageUnit
		});
		try {
			const response = await client.get(`${BASE_URL}/pqy/fcku/fwdCkuStts/v1/lists${queryStr}`);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async getPopupList({ popupSearchParams, printMode }) {
		try {
			const queryStr = objectToQueryString({
				pmcNo: popupSearchParams.pmcNo,
				ipnNos: popupSearchParams.ipnNos,
				custCd: popupSearchParams.custCd,
				cpnyScn: popupSearchParams.cpnyScn,
				saveStatus: popupSearchParams.saveStatus
			});
			const addQueryStr = popupSearchParams.changeCustCd ? '&changeCustCd=Y' : '';
			const printModeStr = printMode ? '&printMode=Y' : '';
			const response = await client.get(`${BASE_URL}/pqy/fcku/fwdCkuTest/v1/lists${queryStr}${addQueryStr}${printModeStr}`);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	/**한번에 공통 코드 부르기 */
	async getCommCodesOnce() {
		try {
			const response = await client.get(`${BASE_URL}/comm/common/custCode/v1/fwdCkuTestCustCodeLists`);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async saveData(params) {
		try {
			const pathVariables = `pmcNo/${params.get('pmcNo')}`;
			const response = await client.post(`${BASE_URL}/pqy/fcku/fwdCkuTest/v1/status/1/${pathVariables}`, params, {
				headers: { 'Content-Type': 'multipart/form-data' }
			});
			return response;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async updateImg(params) {
		try {
			const pathVariables = `pmcNo/${params.get('pmcNo')}/ipnNos/${params.get('ipnNos')}/fwdImg`;
			const response = await client.post(`${BASE_URL}/pqy/fcku/fwdCkuTest/v1/status/2/${pathVariables}`, params, {
				headers: { 'Content-Type': 'multipart/form-data' }
			});
			return response;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async updateOputSt(params) {
		try {
			const pathVariables = `pmcNo/${params.pmcNo}/ipnNos/${params.ipnNos}/oputSt`;
			const response = await client.post(`${BASE_URL}/pqy/fcku/fwdCkuTest/v1/status/2/${pathVariables}`, params);
			return response;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async fileDownload(params) {
		// 이미지 미리보기와 실제파일 다운로드에서 같이 사용하기 때문에 주의할것
		try {
			const response = await client.post(`${BASE_URL}/uploadForm/v1/downloadFile`, params, { responseType: 'blob' });
			return response;
		} catch (error) {
			throw error.response?.data;
		}
	}
};
